const imaEvents = {
    AdEvent: {
        AD_REQUESTED: 'ima.ad.requested',
        AD_LOADED: 'ima.ad.loaded',
        AD_STARTED: 'ima.ad.started',
        AD_SKIPPED: 'ima.ad.skipped',
        AD_IMPRESSION: 'ima.ad.impression',
        AD_PROGRESS: 'ima.ad.progress',
        AD_PAUSED: 'ima.ad.paused',
        AD_RESUMED: 'ima.ad.resumed',
        AD_COMPLETED: 'ima.ad.complete',
        ALL_ADS_COMPLETED: 'ima.ad.all.complete',
        AD_ERROR: 'ima.ad.error',
        AD_COMPANIONS_LOADED: 'ima.ad.companions.loaded',
        AD_COMPANIONS_LOAD_ERROR: 'ima.ad.companions.load.error',
        AD_VOLUME_CHANGED: 'ima.ad.volume.changed',
        AUTOPLAY_DISALLOWED_ERROR: 'ima.autoPlay.disallowed.error',
    },
    VideoEvent: {
        AD_REQUESTED: 'ima.video.ad.requested',
        AD_MANAGER_LOADED: 'ima.video.ad.manager.loaded',
        AD_LOADED: 'ima.video.ad.loaded',
        AD_STARTED: 'ima.video.ad.started',
        AD_SKIPPED: 'ima.video.ad.skipped',
        AD_IMPRESSION: 'ima.video.ad.impression',
        AD_PROGRESS: 'ima.video.ad.progress',
        AD_PAUSED: 'ima.video.ad.paused',
        AD_RESUMED: 'ima.video.ad.resumed',
        AD_COMPLETED: 'ima.video.ad.complete',
        ALL_ADS_COMPLETED: 'ima.video.ad.all.complete',
        AD_ERROR: 'ima.video.ad.error',
        AD_COMPANIONS_LOADED: 'ima.video.ad.companions.loaded',
        AD_VOLUME_CHANGED: 'ima.video.ad.volume.changed',
    },
    AudioEvent: {
        AD_REQUESTED: 'ima.audio.ad.requested',
        AD_MANAGER_LOADED: 'ima.audio.ad.manager.loaded',
        AD_LOADED: 'ima.audio.ad.loaded',
        AD_STARTED: 'ima.audio.ad.started',
        AD_SKIPPED: 'ima.audio.ad.skipped',
        AD_IMPRESSION: 'ima.audio.ad.impression',
        AD_PROGRESS: 'ima.audio.ad.progress',
        AD_PAUSED: 'ima.audio.ad.paused',
        AD_RESUMED: 'ima.audio.ad.resumed',
        AD_COMPLETED: 'ima.audio.ad.complete',
        ALL_ADS_COMPLETED: 'ima.audio.ad.all.complete',
        AD_ERROR: 'ima.audio.ad.error',
        AD_COMPANIONS_LOADED: 'ima.audio.ad.companions.loaded',
        AD_VOLUME_CHANGED: 'ima.audio.ad.volume.changed',
    },
};
export default imaEvents;
